// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"loder_loaderWrapper__SGlws","loader":"loder_loader__8xu1X","l5":"loder_l5__qQCvh"};